// @flow

import * as React from 'react';
import { Tabs } from 'antd';
import Screen from '../../Components/Screen';
import RightSidebar from '../../Components/RightSidebar';
import Initializing from './Components/Initializing';
import Breadcrumbs from './Components/Breadcrumbs';
import Header from './Components/Header';
import Items from './Components/Items';
import Caveats from './Components/Caveats';
import Procurement from './Components/Procurement';
import Footer from './Components/Footer';
import Sidebar from './Components/Sidebar';
import OrderModal from '../../Modals/Order'
import EmailOrderAcknowledgement from '../../Modals/EmailOrderAcknowledgement';
import ClientSiteModal from '../../Modals/ClientSite';
import ClientContactModal from '../../Modals/ClientContact';
import ProjectEditorModal from '../../Modals/Project';
import SubOrderModal from '../../Modals/SubOrder';
import CatalogPicker from './Components/Procurement/Components/CatalogPicker';

type Props = {
  order: any,
  fetching: boolean,
  showOrderModal: boolean,
  showEmailModal: boolean,
  showClientSiteModal: boolean,
  showClientContactModal: boolean,
  projectEditorModal: Object,
  showEmailModal: boolean,
  subOrderModal: Object,
  showCatalogPicker: boolean,

  componentWillMount: (props: any) => void,
  componentWillUnmount: () => void,
  componentDidUpdate: (props: any) => void,

  onChangeTab: Function,
  didUpdateOrder: Function,
  didSendEmail: Function,
  didUpdateClientSite: Function,
  didUpdateClientContact: Function,
  onCloseOrderModal: Function,
  onCloseEmailModal: Function,
  onCloseClientContactModal: Function,
  onCloseClientSiteModal: Function,
  onCloseProjectEditorModal: Function,
  onCloseSubOrderModal: Function,
  onClickHideCatalogPicker: Function,
}

export default class extends React.PureComponent<Props> {

  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef();
    this.state = {
      sidebarOpen: false,
    };
  }

  toggleSidebar = () => {
    this.setState(prevState => ({ sidebarOpen: !prevState.sidebarOpen }));
  };

  componentWillMount = () => this.props.componentWillMount(this.props);

  componentDidUpdate = () => this.props.componentDidUpdate(this.props);

  componentWillUnmount = () => this.props.componentWillUnmount();

  render () {

    const {
      order,
      fetching,
      showOrderModal,
      showEmailModal,
      showClientSiteModal,
      showClientContactModal,
      projectEditorModal,
      subOrderModal,
      showCatalogPicker,
      onChangeTab,
      didUpdateOrder,
      didSendEmail,
      didUpdateClientSite,
      didUpdateClientContact,
      onCloseOrderModal,
      onCloseEmailModal,
      onCloseClientContactModal,
      onCloseClientSiteModal,
      onCloseProjectEditorModal,
      onCloseSubOrderModal,
      onClickHideCatalogPicker,
    } = this.props;

    if (!order) return <Initializing />

    return (

      <Screen className="order-view-screen" style={{ marginRight: 280, paddingRight: 30 }}>

        <style>{`
          @media (max-width: 768px) {
            .order-view-screen {
              margin-right: 0 !important;
              padding-right: 15px !important;
            }
          }
        `}</style>

        <Breadcrumbs
          sidebarOpen={this.state.sidebarOpen}
          onToggleSidebar={this.toggleSidebar}
        />

        <Header />

        <Tabs
          defaultActiveKey={order.extra_works === 2 ? 'PROCUREMENT' : 'ITEMS'}
          animated={false}
          onChange={onChangeTab}
        >

          <Tabs.TabPane tab="ITEMS" key="ITEMS">
            <Items />
          </Tabs.TabPane>

          <Tabs.TabPane tab="CAVEATS" key="CAVEATS">
            <Caveats />
          </Tabs.TabPane>

          <Tabs.TabPane tab="PROCUREMENT" key="PROCUREMENT">
            <Procurement />
          </Tabs.TabPane>

        </Tabs>

        <Footer />

        <RightSidebar
          ref={this.sidebarRef}
          isOpen={this.state.sidebarOpen}
          onToggle={this.toggleSidebar}
          width={280}
        >
          <Sidebar />
        </RightSidebar>

        {showOrderModal && (
          <OrderModal
            order={order}
            onClose={onCloseOrderModal}
            didUpdate={didUpdateOrder}
          />
        )}

        {showEmailModal && (
          <EmailOrderAcknowledgement
            order={order}
            onClose={onCloseEmailModal}
            didSend={didSendEmail}
          />
        )}

        {showClientSiteModal && (
          <ClientSiteModal
            onClose={onCloseClientSiteModal}
            didUpdate={didUpdateClientSite}
            clientSite={order.project.client_site}
          />
        )}

        {showClientContactModal && (
          <ClientContactModal
            onClose={onCloseClientContactModal}
            didUpdate={didUpdateClientContact}
            clientContact={order.client_contact}
          />
        )}

        {projectEditorModal.show && (
          <ProjectEditorModal
            {...projectEditorModal}
            onClose={onCloseProjectEditorModal}
          />
        )}

        {subOrderModal.show && (
          <SubOrderModal
            {...subOrderModal}
            onClose={onCloseSubOrderModal}
          />
        )}

        {showCatalogPicker && (
          <CatalogPicker
            onClose={onClickHideCatalogPicker}
          />
        )}

      </Screen>

    )
  }
}
